import { zetApi } from '@zet/network'

export async function getUpcomingTrainings(
  offset = 0,
  type: string,
  language: string
) {
  const { data } = await zetApi.get(
    `training/getTrainings/v2?type=${type}&language=${language}&offset=${
      offset || 0
    }&limit=10`
  )

  return {
    nextOffset: offset + 1,
    data: data?.data?.webinars,
    total: data?.data?.total || 0,
  }
}
